// extracted by mini-css-extract-plugin
export default {"title":"AiPhotoGenerationResetModal__title--2CtOM","description":"AiPhotoGenerationResetModal__description--1qoin"};